// scheduleActivities.ts
import type { ActivityGroupStatus, ISchedulerTask } from '../../interfaces/IScheduler.js';
import type { ICommittedActivity } from '../../apis/activities.js';

export interface IScheduleActivities {
  /** The committed tasks of the one schedule on screen, in feed order. */
  tasks: ISchedulerTask[];
  /** Trusstor's own status for each committed activity — what the plan status
   *  can't say (`inProgress` / `delayed` / `overdue` come from the tags). Keyed
   *  by task id because `activityId ≡ taskId`; an administrative activity has
   *  no status and no entry. */
  activityStatusById: Map<string, ActivityGroupStatus>;
}

/**
 * The committed-activity feed narrowed to ONE schedule. The feed is site-scoped
 * (a site can hold promises from more than one schedule); a page renders one
 * schedule at a time, so rows from another stay out of the list its groups and
 * dependencies describe. Web and mobile both read their rows through this.
 */
export function activitiesOfSchedule(
  committed: readonly ICommittedActivity[],
  scheduleNumber: string | undefined,
): IScheduleActivities {
  const rows = committed.filter((row) => row.scheduleNumber === scheduleNumber);
  return {
    tasks: rows.map((row) => row.task),
    activityStatusById: new Map(
      rows.flatMap((row) => (row.activityStatus ? [[row.task.id, row.activityStatus] as const] : [])),
    ),
  };
}
